import { useEffect, useState } from 'react'

type TimeLeft = {
  hours: string
  minutes: string
  seconds: string
}

const pad = (value: number): string => String(Math.max(value, 0)).padStart(2, '0')

export function useCountdown(durationMs: number): TimeLeft {
  const [deadline] = useState(() => Date.now() + durationMs)
  const [remaining, setRemaining] = useState(durationMs)

  useEffect(() => {
    const tick = () => setRemaining(Math.max(deadline - Date.now(), 0))
    tick()
    const id = window.setInterval(tick, 1000)
    return () => window.clearInterval(id)
  }, [deadline])

  const totalSeconds = Math.floor(remaining / 1000)

  return {
    hours: pad(Math.floor(totalSeconds / 3600)),
    minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
    seconds: pad(totalSeconds % 60),
  }
}
